var fn = function( obj ){
var __t,__p='';
__p+='precision lowp float;\n\nuniform float uOpacity;\nuniform sampler2D uTexture;\nvarying vec2 vUvs;\nvarying float vAlpha;\n\nvoid main(void){\n  vec3 color = texture2D(uTexture, vUvs.yx).rgb;\n  gl_FragColor = vec4(color * (vAlpha*uOpacity), 1.0);\n}';
return __p;
};
fn.toString=fn;
module.exports = fn;